import React,{useState} from "react";
import { Modal } from 'react-responsive-modal';

const CreateNewChatbot = ({isOpen, setIsOpen}) => {

  const onOpenModal = () => setIsOpen(true);
  const onCloseModal = () => setIsOpen(false);
  return (
    <div>
      <Modal open={isOpen} onClose={() => setIsOpen(false)} center>
      <h2 className="font-medium text-[20px]">Create New</h2>
        <div className="mt-[20px] mb-[20px] ">
            <input placeholder="Select Ai Model" className="focus-visible:outline-none placeholder:text-black border border-[#dbdcde] p-[6px] w-full rounded-lg" type="text" />
        </div>
        <div>
            <button className="second-btn w-full flex justify-center items-center">Submit</button>
        </div>
      </Modal>
    </div>
  );
};

export default CreateNewChatbot;
